var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCopied(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2.925 3.1136",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-108.81 183.09)",
    fill: "none",
    stroke: "#000",
    strokeDashoffset: 11.411,
    strokeWidth: 0.18521
  }, /*#__PURE__*/React.createElement("path", {
    d: "m109.71-182.5h-.43644c-.2078 0-.37509.16728-.37509.37508v1.6836c0 .2078.16729.37509.37509.37509h1.1781c.20779 0 .37508-.16729.37508-.37509v-.11959",
    style: {
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.71,
    y: -183,
    width: 1.9283,
    height: 2.4337,
    rx: 0.37508,
    ry: 0.37508,
    style: {
      paintOrder: "stroke markers fill"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.76501 0 0 .76501 4.6963 -2.3202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.702 5.6252c.48828 0 .8841-.39583.8841-.8841 0-.48827-.39582-.8841-.8841-.8841-.48827 0-.8841.39582-.8841.8841 0 .48828.39582.8841.8841.8841z",
    strokeWidth: 0.046142
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-4.1129 4.7137.32596.34061.54505-.55022",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1744
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopied);
export default __webpack_public_path__ + "static/media/icon_copied.aa0b46b1c46c8e2d3bda6602ac1f1eaf.svg";
export { ForwardRef as ReactComponent };